import { useQuery } from "@tanstack/react-query";
import { querySeasonalityPublic, type EdgeResponse } from "../lib/seasonalityApi";
import type {
  IstatArriviPresenze,
  ArriviPresenzeIndicator,
} from "../types/database";

// ============================================
// RAW ARRIVI/PRESENZE DATA
// ============================================

export function useArriviPresenze(
  comune?: string,
  provincia?: string,
  anno?: number,
  regione?: string,
) {
  return useQuery({
    queryKey: ["arrivi-presenze", comune, provincia, anno, regione],
    queryFn: async () => {
      const result = await querySeasonalityPublic<EdgeResponse<IstatArriviPresenze[]>>(
        "arrivi-presenze",
        { comune, provincia, year: anno, region: regione },
      );
      return result.data || [];
    },
  });
}

// ============================================
// COMPUTED INDICATORS (17 indicators)
// ============================================

export function useArriviIndicators(
  comune?: string,
  provincia?: string,
  anno?: number,
  regione?: string,
) {
  return useQuery({
    queryKey: ["arrivi-indicators", comune, provincia, anno, regione],
    queryFn: async () => {
      const result = await querySeasonalityPublic<EdgeResponse<ArriviPresenzeIndicator[]>>(
        "arrivi-indicators",
        { comune, provincia, year: anno, region: regione },
      );
      return result.data || [];
    },
  });
}

// ============================================
// FILTER OPTIONS (regioni -> province -> comuni)
// ============================================

interface ArriviOptions {
  regioni: string[];
  hierarchy: Record<string, Record<string, string[]>>;
}

export function useArriviOptions(anno?: number, regione?: string) {
  return useQuery({
    queryKey: ["arrivi-options", anno, regione],
    queryFn: async () => {
      const result = await querySeasonalityPublic<EdgeResponse<ArriviOptions>>(
        "arrivi-options",
        { year: anno, region: regione },
      );
      return result.data;
    },
  });
}

// ============================================
// YoY VARIATION
// ============================================

export interface ArriviVariazione {
  comune: string;
  provincia: string | null;
  regione: string | null;
  anno_corrente: number;
  anno_precedente: number;
  var_pct_arrivi: number | null;
  var_pct_presenze: number | null;
  var_pct_esercizi: number | null;
  var_pct_letti: number | null;
}

export function useArriviVariazione(
  comune?: string,
  provincia?: string,
  anno?: number,
  regione?: string,
) {
  return useQuery({
    queryKey: ["arrivi-variazione", comune, provincia, anno, regione],
    queryFn: async () => {
      const result = await querySeasonalityPublic<EdgeResponse<ArriviVariazione[]>>(
        "arrivi-variazione",
        { comune, provincia, year: anno, region: regione },
      );
      return result.data || [];
    },
  });
}
